import React from "react";
import { CryptoDepositHistory } from "./CryptoDepositSections";
import { formatDate, getHistoryStatus } from "./financeWallet.helpers";

const WalletHistorySection = ({
  currentPage,
  historyCount,
  historyRows,
  historySkeletonRows,
  historyTitle,
  isCryptoHistory,
  isLoading,
  onNextPage,
  onPreviousPage,
  renderAmount,
  renderLabel,
  totalPages,
}) => (
  <section className="wallet-history">
    <div className="wallet-history-header">
      <h4>{historyTitle}</h4>
      <span>{historyCount ? `${historyCount}건` : ""}</span>
    </div>

    {isCryptoHistory ? (
      <CryptoDepositHistory
        historyRows={historyRows}
        historySkeletonRows={historySkeletonRows}
        isLoading={isLoading}
      />
    ) : (
      <div className="wallet-history-table">
        <div className="wallet-history-row is-head">
          <span>구분</span>
          <span>시간</span>
          <span>금액</span>
          <span>상태</span>
        </div>

        {isLoading ? (
          Array.from({ length: historySkeletonRows }).map((_, index) => (
            <div
              className="wallet-history-row is-skeleton"
              role="status"
              aria-label="내역 불러오는 중"
              key={`wallet-skeleton-${index}`}
            >
              <i />
              <i />
              <i />
              <i />
            </div>
          ))
        ) : historyRows.length ? (
          historyRows.map((row, index) => {
            const status = getHistoryStatus(row);
            return (
              <div className="wallet-history-row" key={row?.id || row?._id || index}>
                <span>{renderLabel(row)}</span>
                <span>{formatDate(row)}</span>
                <span>{renderAmount(row)}</span>
                <span className={status.className}>{status.label}</span>
              </div>
            );
          })
        ) : (
          <div className="wallet-empty-history">표시할 내역이 없습니다.</div>
        )}
      </div>
    )}

    <div
      className={`wallet-history-pager ${totalPages > 1 ? "" : "is-hidden"}`}
      aria-hidden={totalPages <= 1}
    >
      {totalPages > 1 ? (
        <>
          <button
            type="button"
            aria-label="이전 페이지"
            disabled={currentPage <= 1 || isLoading}
            onClick={onPreviousPage}
          >
            ‹
          </button>
          <span>
            {currentPage} / {totalPages}
          </span>
          <button
            type="button"
            aria-label="다음 페이지"
            disabled={currentPage >= totalPages || isLoading}
            onClick={onNextPage}
          >
            ›
          </button>
        </>
      ) : (
        <span>1 / 1</span>
      )}
    </div>
  </section>
);

export default WalletHistorySection;
